<template>
  <div class="card-link">
    <card-box :routerName=routerName :target="target">
      <card-header>
        <span class="title">{{ title }}</span>
        <span v-if="badge" class="badge"><badge-icon class="-md -requires">{{badge}}</badge-icon></span>
      </card-header>
      <card-body>
        <div class="img-box">
          <img :src="image_src" class="img" />
        </div>
        <span class="desc"><slot></slot></span>
      </card-body>
    </card-box>
  </div>
</template>

<script>

import CardBox from './CardBox'
import CardHeader from './CardHeader'
import CardBody from './CardBody'
import BadgeIcon from '../badges/BadgeIcon'

export default {
  name: 'card-link',
  components: {
    CardBox,
    CardHeader,
    CardBody,
    BadgeIcon
  },
  props: {
    title: {type: String},
    badge: {type: String},
    src: {type: String},
    routerName: {type: String},
    target: {type: String}
  },
  computed: {
    image_src () {
      return require('@/assets/images/' + this.src)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";

.card-link {
  @include mq-down(md) {
    margin-left: 20px;
    margin-right: 20px;
  }
  >.card-box {
    .card-header {
      padding: 18px;
      border-radius: 10px 10px 0 0;
      font-size: 16px;
      font-weight: normal;
      @include mq-up(md) {
        padding: 24px 30px;
        font-size: 20px;
      }
      border-bottom: 1px solid $secondary;
      background-image: url('../../assets/images/icons/arrow-right-orange.svg');
      background-size: 8px auto;
      background-position: right 18px center;
      background-repeat: no-repeat;
      @include mq-up(md) {
        background-position: right 32px center;
      }
      @include flex(flex,normal,center,row,nowrap);
      >.title {
        display: inline-block;
        width: 90%;
      }
      >.badge {
        padding-left: 15px;
      }
    }
    .card-body {
      @include flex(flex,space-around,flex-start,row,nowrap);
      padding: 20px 20px;
      @include mq-up(md) {
        padding: 20px 30px;
      }
      >.desc {
        padding-left: 20px;
        @include mq-up(md) {
          padding-left: 30px;
        }
      }
      >.img-box {
        @include mq-up(md) {
          max-width: 120px;
        }
        >.img {
          width: 90px;
          height: auto;
          @include mq-up(md) {
            width: 120px;
          }
        }
      }
    }
    >.-anchor:hover {
      >.card-body {
        >.img {
          opacity: .7;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/card/CardLink.vue